import React from 'react';

import {DATA_FRAME_DISPLAY_ROW_LIMIT} from 'analysis-tool/AnalysisToolConstants';
import {DataFrame} from 'data-frames/DataFrameTypes';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {PrimaryActionRenderFn, ToolbarActionRenderParams} from '../DataFrameActionToolbar';

function getIsDisabledAndTooltipText(
  dataFrame: DataFrame,
  flaggedRows: Set<string>,
  selectedRows: Set<string>
): {isDisabled: boolean; tooltipText: string | null} {
  if (dataFrame.numRows && dataFrame.numRows > DATA_FRAME_DISPLAY_ROW_LIMIT) {
    return {
      isDisabled: true,
      tooltipText: 'Clearing flags is disabled for large tables.',
    };
  }
  if (selectedRows.size === 0) {
    return {
      isDisabled: true,
      tooltipText: null,
    };
  }
  if (Array.from(selectedRows).every((rowId) => !flaggedRows.has(rowId))) {
    return {
      isDisabled: true,
      tooltipText: 'No flagged rows are selected.',
    };
  }
  return {isDisabled: false, tooltipText: null};
}

export function getRenderClearFlagRowsButtonFn(
  onClick: (selectedRowIds: Set<string>) => void,
  flaggedRows: Set<string>
): PrimaryActionRenderFn {
  return (dataFrame: DataFrame, params: ToolbarActionRenderParams) => {
    const {isDisabled, tooltipText} = getIsDisabledAndTooltipText(
      dataFrame,
      flaggedRows,
      params.selectedRowIds
    );
    return (
      <Tooltip text={tooltipText} isDisabled={!isDisabled} key="ClearFlagRowsButtonTooltip">
        <Button
          key="ClearFlagRowsButton"
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          className="u-mini-spacing-left"
          icon="flag-slash"
          onClick={() => {
            onClick(params.selectedRowIds);
          }}
          disabled={isDisabled}
          size={ButtonSize.MINI}
          text="Clear"
        />
      </Tooltip>
    );
  };
}
